import { useEffect, useState } from "react";
import { Toaster } from "sonner";
import { api, getToken, setToken } from "@/lib/adminApi";
import AdminLogin from "@/components/admin/AdminLogin";
import AdminDashboard from "@/components/admin/AdminDashboard";

export default function Admin() {
    const [user, setUser] = useState(null); // null = checking, false = signed out

    useEffect(() => {
        if (!getToken()) {
            setUser(false);
            return;
        }
        api.get("/auth/me")
            .then((r) => setUser(r.data))
            .catch(() => {
                setToken(null);
                setUser(false);
            });
    }, []);

    const signOut = () => {
        setToken(null);
        setUser(false);
    };

    return (
        <div className="min-h-screen bg-background text-foreground" data-testid="admin-page">
            {user === null ? (
                <div className="flex min-h-screen items-center justify-center font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground">
                    Checking session…
                </div>
            ) : user ? (
                <AdminDashboard user={user} onSignOut={signOut} />
            ) : (
                <AdminLogin onSuccess={setUser} />
            )}
            <Toaster position="bottom-right" theme="light" />
        </div>
    );
}
